<template>
  <ats
    v-bind="$props"
    service="taleez"
    :savingConf="savingConf"
    :credential="{
      apiSecret: '',
      apiKey: ''
    }"
    :cached="true"
    :multiai="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div>
        <label for="apiSecret">api secret</label>
        <input v-model="credential.apiSecret" id="apiSecret" name="apiSecret"/>
        <modified :enable="value.credential.apiSecret !== credential.apiSecret"/>
      </div>
      <div>
        <label for="apiKey">api publique</label>
        <input v-model="credential.apiKey" id="apiKey" name="apiKey"/>
        <modified :enable="value.credential.apiKey !== credential.apiKey"/>
      </div>
      <div class="meta">
        <label for="meta">meta</label>
        <textarea v-model="metaConfig" cols='50' id="meta" name="meta" :placeholder="placeholder"></textarea>
        <modified :enable="value.credential.metaConfig !== credential.metaConfig"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.taleez.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  data () {
    return {
      metaConfig: JSON.stringify(this.value.meta),
      placeholder: '{"initialReferrer":"Hippolyte-rh"}'
    }
  },
  methods: {
    onInput (event) {
      event.meta = this.metaConfig ? JSON.parse(this.metaConfig) : ''
      this.$emit('input', event)
    }
  }
}
</script>
